
const config: any = {
  rowSelection: false,
  fieldControl: false,
  searchFormConfig: false,
  searchMode: "group",
  columns: [
    {
      title: '分公司',
      dataIndex: 'companyName',
      width: 120,
    },
    {
      title: '排序',
      dataIndex: 'rankingWeight',
      width: 120,
    },
    {
      title: '区域',
      dataIndex: 'name',
      width: 120,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: "dateTime",
      width: 150,
    },
    {
      title: '修改时间',
      dataIndex: 'lastUpdatedTime',
      itemType: "dateTime",
      width: 150,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 80,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'name',
      label: '楼盘区域名称',
      labelProps: {
        "width": 90
      }
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
      // auth: 'AddBuildingAreaButton',
    },
  ],
}
export default config